import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Paper,
  Skeleton,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { EnumStatisticChartType } from "../../../../../server/routes/statistic/types";
import ChartLine from "../../../components/ChartLine";
import useMarketplacesFilter from "../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import { useHideFakeOrders } from "../../../components/HideFakeOrdersProvider";
import numberFormat from "../../../utils/formatNumber";
import { useStatusGroup } from "../StatusGroupProvider";
import Actions from "./Actions";
import FieldDates from "./Actions/FieldDates";
import SelectorType from "./SelectorType";
import useLoadingAnyDateChart from "./hooks/useLoadingAnyDateChart";
import prepareChartData from "./prepareChartData";
import { ChartFC } from "./types";

const Chart: ChartFC = ({ actions }) => {
  const { statusGroup, chartTitle, additionalChart } = useStatusGroup();
  const { isLoading, statisticChart } = useSelector(({ statisticChart }) => ({
    statisticChart,
    isLoading: statisticChart[statusGroup].sending,
  }));
  const { list } = useMarketplacesFilter();

  const { status: hideFakeOrders } = useHideFakeOrders();
  const loading = useLoadingAnyDateChart(hideFakeOrders);
  const {
    isLoading: filteringMarketplacesloading,
    active: filteringMarketplaces,
  } = useMarketplacesFilter();
  useEffect(() => {
    loading();
  }, [filteringMarketplacesloading, filteringMarketplaces, hideFakeOrders]);
  const chartData = useMemo(() => {
    return statisticChart[statusGroup].data
      ? prepareChartData(
          // @ts-ignore
          Object.entries(statisticChart[statusGroup].data).map(
            ([marketplace, values], index) => {
              return {
                data: values,
                  color: list.find(item => item.old.type === marketplace)?.color || "primary",
                marketplace,
              };
            }
          ),
          statisticChart[statusGroup].period,
          statisticChart[statusGroup].type
        )
      : [];
  }, [statisticChart[statusGroup].data, statusGroup]);
  const labelsChart = Object.keys(chartData[0]?.data ?? {});

  return (
    <Card component={Paper}>
      <CardHeader
        title={chartTitle}
        action={<Actions actions={actions} />}
        sx={{
          flexWrap: "wrap",
          gap: 2,
          "& .MuiCardHeader-action": {
            flex: "initial",
          },
        }}
      />
      <Divider />
      <CardContent style={{ marginTop: "-16px" }}>
        <Box padding={1}>
          <Grid container>
            <FieldDates loading={loading} />
            <SelectorType loading={loading} />
          </Grid>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12}>
            <Box sx={{ height: 245 }}>
              {isLoading && !chartData ? (
                <Skeleton height={245} width={"100%"} variant={"rectangular"} />
              ) : (
                <ChartLine
                  labels={labelsChart}
                  tooltipCallbacks={{
                    title: () => "",
                    label: (tooltipItem) => {
                      const value = +tooltipItem.formattedValue
                        .replace(/\s/g, "")
                        .replace(",", ".");
                      const marketplaceItem = list.find(item => item.old.type === tooltipItem.dataset.marketplace);
                      const title = marketplaceItem ? marketplaceItem.name : "Итого";
                      switch (statisticChart[statusGroup].type) {
                        case EnumStatisticChartType.MARGINALITY_PERCENT:
                          return `${numberFormat(value, 0)} - ${title}`;
                        default:
                          return `${numberFormat(value, 0)} - ${title}`;
                      }
                    },
                  }}
                  data={chartData}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Chart;
